import { startCase as _startCase } from 'lodash';

import jsonApi from '@/services/api/json_api_service';
import resourceService from './resource_service';

const modelName = 'subscription';

const attributes = {
  recipient: '',
  subscriptionType: '',
  sendInterval: '',
  deliveryMethod: '',
  interval: '',
  separator: '',
};

const relationships = {
  site: {
    jsonApi: 'hasOne',
  },
};

const readOnlyAttributes = ['interval'];

const formatters = {
  typeName: (attrs) => {
    return _startCase(attrs.subscriptionType);
  },
};

const Resource = resourceService(modelName, attributes, relationships, readOnlyAttributes);

Resource.model.formatters = formatters;

Resource.index = (options) => {
  jsonApi.auth();
  const newOptions = {
    filter: {
      subscriptionType: 'AllocationConsumption,AllocationDispense',
      ...options.filter,
    },
    ...options,
  };
  return jsonApi.findAll(modelName, newOptions);
};

export default Resource;
